var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader text-center"},[_c('small',[_vm._v(_vm._s(_vm.I18n.t("loading")))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d8e1ddf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/shared/components/loader.vue
// module id = 604
// module chunks = 0 1 2 3 4 5 6 7 8 10 20 22 25 35 351